module.exports = __webpack_public_path__ + "img/stageSection02.243a1b05.png";